"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AccessLevel;
(function (AccessLevel) {
    AccessLevel[AccessLevel["CATEGORY"] = 1] = "CATEGORY";
    AccessLevel[AccessLevel["WORKFLOW"] = 2] = "WORKFLOW";
    AccessLevel[AccessLevel["FIELDS"] = 3] = "FIELDS";
    AccessLevel[AccessLevel["WORKFLOWFIELDS"] = 4] = "WORKFLOWFIELDS";
})(AccessLevel = exports.AccessLevel || (exports.AccessLevel = {}));
//# sourceMappingURL=access-level.enum.js.map